import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Link,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import Navbar from "../components/Navbar";
import darkLogo from "../assets/images/Newlogo-black.png";
import BackToTopButton from "../components/common/BackToTopButton";
import Footer from "./Footer";
import JoinCommunitySection from "./common/JoinCommunitySection";
import { Helmet } from "react-helmet-async";

const TermsOfService = () => {
  return (
    <><Helmet>
    <title>Terms of Service&nbsp;| NOMAD360</title>
  </Helmet>

    <Box position="absolute" top={0} left={0} width="100%" zIndex="2">
      <Navbar
        bgColor="white"
        linkColor="black"
        styling="outline"
        logoSrc={darkLogo}
        languageCodeColor="black"
        userProfileBgColor="transparent"
      />
      <Box
        maxW={{ base: "100vw", sm: "85vw", md: "85vw", lg: "60vw" }}
        mx="auto"
        px={4}
        py={8}
        pt={8}
      >
        {/* Main Title */}
        <Heading as="h1" size="xl" align="center" mt={10} mb={10}>
          GENERAL CONDITIONS OF USE AND DELIVERY NOMAD360
        </Heading>

        <VStack align="start" spacing={3}>
          {/* Introductory Information */}
          <Text mb={0} fontStyle="italic">
            These general terms and conditions consist of the following
            sections:
          </Text>
          <VStack align="start" spacing={1}>
            <Text mb={0}>1. General provisions</Text>
            <Text mb={0}>2. Terms of use NOMAD360</Text>
            <Text mb={0}>
              3. Specific provision regarding Input and Content
            </Text>
          </VStack>
          <Text mb={0}>NOMAD360 is offered by:</Text>
          <Text fontStyle="italic" mb={0}>
            <strong>Lancewood AI Solutions B.V.</strong>
            <br />
            Westplein 12
            <br />
            3016 BM Rotterdam
            <br />
            The Netherlands
            <br />
            Chamber of Commerce number: 95481214
            <br />
            VAT number: NL867147507B01
            <br />
            info@lancewood.nl
          </Text>

          <Text fontStyle="italic" mb={0}>
            These general terms and conditions were last updated on: April 14,
            2025.
          </Text>

          {/* CHAPTER 1 */}
          <Heading as="h2" size="lg" mt={6}>
            CHAPTER 1 - GENERAL PROVISIONS
          </Heading>

          {/* 1. Applicability */}
          <Heading as="h3" size="md">
            1. Applicability of these general terms and conditions
          </Heading>
          <Text>
            1.1. These general terms and conditions apply to all services
            offered by Lancewood AI Solutions through NOMAD360. Specific
            conditions relating to the use of NOMAD360 and Input and Content are
            elaborated in Chapter II - Terms of use of NOMAD360 and Chapter III
            - Specific provisions regarding Input and Content, respectively.
          </Text>
          <Text>
            1.2. By using NOMAD360, User agrees to these terms and conditions.
            Deviations from or additions to these general terms and conditions
            are valid only if confirmed in writing by Lancewood AI Solutions.
          </Text>
          <Text>
            1.3. Any general purchasing and/or other general terms and
            conditions of the User are expressly rejected by Lancewood AI
            Solutions.
          </Text>
          <Text>
            1.4. If one or more provisions of these general terms and conditions
            are found to be non-binding or invalid, the remaining provisions
            shall remain in full force and effect.
          </Text>

          {/* 2. Definitions */}
          <Heading as="h3" size="md">
            2. Definitions
          </Heading>
          <Text>
            2.1. The terms indicated with an initial capital letter in these
            general terms and conditions may be used in either singular or
            plural and shall have the following meanings:
          </Text>
          <Text>
            <strong>Account:</strong> the personal user profile that the User
            creates with an e-mail address and password, or via logging in with
            a Google account, to access a User Environment within NOMAD360;
          </Text>
          <Text>
            <strong>AI model:</strong> the Large Language Model (LLM) used by
            Lancewood AI Solutions, which uses artificial intelligence to
            generate Content based on User Input and data from external data
            sources, such as data brokers;
          </Text>
          <Text>
            <strong>Content:</strong> any data, information, materials, or other
            content generated or edited by or through NOMAD360, whether or not
            based on the User’s Input. Content includes, but is not limited to,
            User Input, data provided by third parties, and information
            generated or optimized by the AI model.
          </Text>
          <Text>
            <strong>User:</strong> the natural person who uses NOMAD360 and
            holds an Account;
          </Text>
          <Text>
            <strong>User Environment:</strong> a private part of NOMAD360 to
            which (only) the User has access;
          </Text>
          <Text>
            <strong>Input:</strong> any data, including Personal Data,
            information, materials or other content, in any form, provided,
            uploaded or entered by the User into NOMAD360, either directly or
            through third party(ies), for the purpose of generating Content;
          </Text>
          <Text>
            <strong>Lancewood AI Solutions:</strong> the private company with
            limited liability Lancewood AI Solutions B.V., having its registered
            office at Westplein 12, 3016 BM in Rotterdam, The Netherlands, and
            registered with the Chamber of Commerce under Chamber of Commerce
            number: 95481214;
          </Text>
          <Text>
            <strong>NOMAD360:</strong> the software application provided by
            Lancewood AI Solutions, accessible via nomad360.io and available as
            an Android and iOS mobile application, which acts as a virtual
            travel guide. NOMAD360 uses the AI model to support Users in
            planning and booking trips;
          </Text>
          <Text>
            <strong>Personal data:</strong> any information about an identified
            or identifiable natural person, including, but not limited to,
            names, address details, financial details and other personal
            information provided by the User to Lancewood AI Solutions through
            NOMAD360.
          </Text>

          {/* 3. Modification */}
          <Heading as="h3" size="md">
            3. Modification of these general terms and conditions
          </Heading>
          <Text>
            3.1. Lancewood AI Solutions reserves the right to amend these terms
            and conditions. Any changes will be announced at least 30 (thirty)
            days before they take effect, via NOMAD360 and/or email. If a
            modification constitutes a material change to the service, the User
            has the right to terminate the agreement with Lancewood AI Solutions
            free of charge. By continuing to use NOMAD360 after the effective
            date of the changes, the User agrees to the revised terms and
            conditions.
          </Text>

          {/* 4. Portability */}
          <Heading as="h3" size="md">
            4. Portability
          </Heading>
          <Text>
            4.1. The rights and obligations arising from these general terms and
            conditions are not transferable by the User to third parties, except
            with the express consent of Lancewood AI Solutions.
          </Text>

          {/* 5. Privacy */}
          <Heading as="h3" size="md">
            5. Privacy
          </Heading>
          <Text>
            5.1. The processing of Personal Data by Lancewood AI Solutions is
            carried out in accordance with applicable privacy laws and Lancewood
            AI Solutions' privacy statement. For more information on how
            Lancewood AI Solutions handles the protection and processing of
            Users' Personal Data, please refer to Lancewood AI Solutions'
            privacy statement which can be found at{" "}
            <Link
              color="blue.500"
              href="https://nomad360.io/policies/privacy-policy"
            >
              nomad360.io/policies/privacy-policy
            </Link>
            . Prior to using NOMAD360, the User shall review this privacy
            statement and raise any objections if necessary.
          </Text>

          {/* 6. Force majeure */}
          <Heading as="h3" size="md">
            6. Force majeure
          </Heading>
          <Text>
            6.1. Lancewood AI Solutions shall not be liable to User for any
            failure to perform any obligation arising from these Terms and
            Conditions due to force majeure, including, but not limited to,
            natural disasters, terrorism, war, political insurrection,
            rebellion, riots, civil unrest, acts of civil or military
            authorities, insurrection, earthquake, flood or other natural or
            man-made events beyond the control of Lancewood AI Solutions that
            result in the termination of the service, nor for events that could
            not reasonably have been foreseen.
          </Text>
          <Text>
            6.2. If Lancewood AI Solutions is affected by force majeure, it will
            notify the User as soon as possible and make every reasonable effort
            to comply with the obligations under these general terms and
            conditions.
          </Text>

          {/* 7. Liability */}
          <Heading as="h3" size="md">
            7. Liability
          </Heading>
          <Text>
            7.1. Lancewood AI Solutions shall not be liable for any direct
            damage arising out of or in connection with these terms and
            conditions, regardless of the legal basis on which the claim is
            based (contractual liability, tort or otherwise).
          </Text>
          <Text>
            7.2. If, notwithstanding the provisions of Article 7.1, Lancewood AI
            Solutions is deemed liable for any direct damage, such liability
            shall be limited to a maximum amount of €10,000 per event, whereby a
            series of related events shall be considered as one event.
          </Text>
          <Text>
            7.3. All liability of Lancewood AI Solutions for damages other than
            direct damages is excluded. This includes, but is not limited to,
            indirect damage, consequential damage, damage due to delayed
            delivery, damage due to delayed invoicing, loss and/or damage to
            data, loss of turnover, loss of profits and damage due to an
            interruption in operational work. Lancewood AI Solutions
            specifically excludes damages for:
          </Text>
          <Text pl={4}>
            a. Damages resulting from acts or omissions of third parties (e.g.
            tour operators, accommodations, affiliate partners);
            <br />
            b. Damages due to incorrect or incomplete (travel) information or
            planning functionalities;
            <br />
            c. Damages arising from changes, cancellations or negligence of
            external service providers; and
            <br />
            d. Damage due to failures, interruptions or limited accessibility of
            the platform.
          </Text>
          <Text>
            7.4. The limitations of liability contained in this article shall
            lapse:
          </Text>
          <Text pl={4}>
            (i) in case of claims for damages resulting from death or injury;
            <br />
            (ii) if there is intent or deliberate recklessness on the part of
            Lancewood AI Solutions.
          </Text>
          <Text>
            7.5. A prerequisite for any right to compensation is that the User
            promptly reports the damage to Lancewood AI Solutions in writing, no
            later than 14 days after its occurrence.
          </Text>
          <Text>
            7.6. Any claim for damages against Lancewood AI Solutions shall
            lapse by the mere expiry of twelve (12) months after the occurrence
            of the (alleged) claim.
          </Text>
          <Text>
            7.7. The provisions of this article also apply in favour of all
            (legal) persons which Lancewood AI Solutions engages in the
            execution of NOMAD360.
          </Text>
          <Text>
            7.8. Lancewood AI Solutions shall never be obliged to restore data
            that has been damaged or (partially) lost or to compensate for
            damage caused by damage and/or loss of data.
          </Text>

          {/* 8. Applicable law and competent court */}
          <Heading as="h3" size="md">
            8. Applicable law and competent court
          </Heading>
          <Text>
            8.1. These General Terms and Conditions, along with any agreements
            between the parties and the legal relationships governed by them,
            shall be exclusively governed by Dutch law.
          </Text>
          <Text>
            8.2. If an existing dispute between the parties cannot be settled by
            mutual agreement, and to the extent that the law does not provide
            otherwise, the District Court of The Hague shall have exclusive
            jurisdiction to resolve the dispute.
          </Text>

          {/* CHAPTER 2 */}
          <Heading as="h2" size="lg" mt={6}>
            CHAPTER 2 - TERMS OF USE NOMAD360
          </Heading>

          {/* 9. Scope */}
          <Heading as="h3" size="md">
            9. Scope
          </Heading>
          <Text>
            9.1. These terms of service apply to the use of NOMAD360 in addition
            to and, to the extent that they differ, in derogation of the general
            provisions contained in Chapter I.
          </Text>

          {/* 10. Registration and Account */}
          <Heading as="h3" size="md">
            10. Registration and Account
          </Heading>
          <Text>
            10.1. To use NOMAD360 and purchase services, the User must register
            and create an account by providing a valid email address and
            choosing a password or by logging in with a valid Google account.
          </Text>
          <Text>
            10.2. User is obliged, when registering and creating an Account, to
            declare truthfully whether he/she has reached the age of 16 years or
            older.
          </Text>
          <Text>
            10.3. User is obliged to keep his/her usernames and passwords
            confidential. It is not allowed to transfer user names, passwords
            and/or any provided alternative means of authentication or to give
            them in use to third parties.
          </Text>
          <Text>
            10.4. Lancewood AI Solutions is not liable for misuse of usernames,
            passwords and/or any alternative means of authentication provided
            and may assume that the person logging in using the User's username,
            password and/or any alternative means of authentication provided is
            in fact that User.
          </Text>
          <Text>
            10.5. As soon as the User knows or has reason to suspect that
            usernames, passwords and/or any alternative means of authentication
            provided have fallen into the hands of unauthorized persons, the
            User must notify Lancewood AI Solutions immediately, without
            prejudice to the User's own obligation to take effective measures
            himself/herself immediately.
          </Text>

          {/* 11. Right of use on NOMAD360 */}
          <Heading as="h3" size="md">
            11. Right of use on NOMAD360
          </Heading>
          <Text>
            11.1. By accepting these terms and conditions and creating an
            Account, Lancewood AI Solutions grants User a limited, non-exclusive
            and non-transferable right to use NOMAD360 in accordance with the
            terms of these terms and conditions.
          </Text>
          <Text>
            11.2. For the purposes of the provisions of paragraph 1, Lancewood
            AI Solutions shall provide User with access to NOMAD360 and the User
            Environment.
          </Text>

          {/* 12. Rights and obligations of User */}
          <Heading as="h3" size="md">
            12. Rights and obligations of User
          </Heading>
          <Text>
            12.1. User shall not use NOMAD360 for any actions that violate
            applicable laws and regulations, these general terms and conditions,
            or any instructions, conditions, or guidelines issued by Lancewood
            AI Solutions, whether provided periodically or made available
            digitally through NOMAD360.
          </Text>
          <Text>
            12.2. User shall not copy, modify, decompile, translate, or adapt
            the software used for or within NOMAD360, or any other services
            provided by Lancewood AI Solutions, unless explicit written
            permission has been granted by Lancewood AI Solutions or such
            actions are permitted under mandatory law.
          </Text>
          <Text>
            12.3. User shall not upload or share any unlawful - or in the
            opinion of Lancewood AI Solutions - inappropriate or unnecessarily
            offensive content.
          </Text>
          <Text>
            12.4. User shall not upload any Third Party Input without prior
            express consent of the relevant third party. If the third party is
            under 16 years of age, User shall obtain the prior express consent
            of such third party's parent or legal representative.
          </Text>
          <Text>
            12.5. User will treat other users respectfully in chat groups and
            the social community. Insults, discrimination, threats, harassment,
            hate speech and other forms of unwanted behavior are strictly
            prohibited.
          </Text>
          <Text>
            12.6. Sharing harmful, violent, pornographic, misleading, inaccurate
            or otherwise illegal content is prohibited.
          </Text>
          <Text>
            12.7. User shall not engage in spamming, share commercial promotions
            with other users, send chain letters, or distribute any other forms
            of unsolicited messages.
          </Text>
          <Text>
            12.8. User will not share personal data of themselves or others in
            chat groups or the social community unless strictly necessary and in
            accordance with privacy laws.
          </Text>
          <Text>
            12.9. User will not abuse NOMAD360 through hacking, spamming or
            other forms of abuse.
          </Text>
          <Text>
            12.10. NOMAD360 is intended for personal, non-commercial purposes
            only. Users may only use the Content for private use and may not
            commercially exploit it without express permission from Lancewood AI
            Solutions.
          </Text>

          {/* 13. Rights and obligations of Lancewood AI Solutions */}
          <Heading as="h3" size="md">
            13. Rights and obligations of Lancewood AI Solutions
          </Heading>
          <Text>
            13.1. If Lancewood AI Solutions becomes aware or determines that any
            Input and/or Content stored or uploaded through NOMAD360 is unlawful
            or could result in civil or criminal liability for Lancewood AI
            Solutions, it reserves the right to immediately remove such material
            or disable access to the data. Under no circumstances shall
            Lancewood AI Solutions be liable for any damages arising from such
            actions.
          </Text>
          <Text>
            13.2. Lancewood AI Solutions reserves the right to close User's
            Account without prior notice if User fails to comply with the
            provisions of these terms and conditions.
          </Text>

          {/* 14. Warranty in respect of NOMAD360 */}
          <Heading as="h3" size="md">
            14. Warranty in respect of NOMAD360
          </Heading>
          <Text>
            14.1. NOMAD360 is provided "as is" and "as available". Lancewood AI
            Solutions warrants only that NOMAD360 has been developed and made
            available in accordance with applicable standards in the IT
            industry. The User acknowledges and agrees that NOMAD360 is provided
            by Lancewood AI Solutions with no warranties or obligations other
            than those in these terms and conditions.
          </Text>

          {/* 15. Statistics */}
          <Heading as="h3" size="md">
            15. Statistics
          </Heading>
          <Text>
            15.1. User understands and agrees that NOMAD360 transmits technical
            and usage analyses ("Statistics") to Lancewood AI Solutions and,
            where applicable, to its licensors, affiliates, and service
            providers. The User further agrees that Lancewood AI Solutions
            and/or its licensors and affiliates may, for themselves or third
            parties:
          </Text>
          <Text pl={4}>
            a) Collect, store, and use Statistics; and
            <br />
            b) Transfer such Statistics for the following purposes:
            <br />
            (i) Providing software and other services,
            <br />
            (ii) Enabling new software, updates, enhancements, and other
            services,
            <br />
            (iii) Improving NOMAD360, as well as other software, services, and
            technologies.
          </Text>

          {/* 16. Intellectual property NOMAD360 */}
          <Heading as="h3" size="md">
            16. Intellectual property NOMAD360
          </Heading>
          <Text>
            16.1. Unless otherwise agreed in writing, all intellectual property
            rights related to NOMAD360, including, but not limited to, patent
            rights, copyrights, trademark rights, and database rights, are
            vested in Lancewood AI Solutions, its suppliers, or its licensors.
            User only acquires the usage rights expressly granted in these terms
            and conditions or as provided by law. Only Lancewood AI Solutions is
            authorized to file the necessary applications and registrations to
            protect these rights.
          </Text>
          <Text>
            16.2. If any (future) rights referred to in paragraph 1 arise from
            these general terms and conditions and become vested in the User,
            the User shall cooperate in transferring these rights to Lancewood
            AI Solutions. Such cooperation may include, but is not limited to,
            entering into a formal agreement. If required by law, the User shall
            comply with any necessary formalities for the transfer of these
            rights at Lancewood AI Solutions' first request.
          </Text>

          {/* CHAPTER 3 */}
          <Heading as="h2" size="lg" mt={6}>
            CHAPTER 3 - SPECIFIC PROVISIONS REGARDING INPUT AND CONTENT
          </Heading>

          {/* 17. Scope */}
          <Heading as="h3" size="md">
            17. Scope
          </Heading>
          <Text>
            17.1. The provisions in this Chapter apply to Input and Content that
            is generated or uploaded through NOMAD360. These provisions apply in
            addition to, and, where necessary, by way of derogation from, the
            general provisions outlined in Chapter I.
          </Text>

          {/* 18. Guarantee in respect of Content */}
          <Heading as="h3" size="md">
            18. Guarantee in respect of Content
          </Heading>
          <Text>
            18.1. The Content generated through NOMAD360 is based on User Input
            and data from third-party providers, such as data brokers. Lancewood
            AI Solutions does not guarantee the accuracy, completeness,
            timeliness, or suitability of the Content, including but not limited
            to real-time information on airline tickets, hotels, and travel
            services from third-party data providers. The User is solely
            responsible for verifying and reviewing the generated Content before
            using or relying on it.
          </Text>
          <Text>
            18.2. User understands and acknowledges that NOMAD360's Content is
            generated by an AI model with inherent limitations. The AI model may
            contain errors, misinterpret context, or generate inaccurate
            information. While Lancewood AI Solutions strives to provide
            accurate and reliable Content, it does not guarantee the accuracy or
            completeness of the information. The User is advised to carefully
            evaluate the generated Content and, if necessary, conduct additional
            verification or seek professional advice.
          </Text>
          <Text>
            18.3. User is advised that travel advice or suggestions provided by
            NOMAD360 may not reflect the current security situation in certain
            destinations. Lancewood AI Solutions strongly recommends consulting
            official government travel advisories, such as those issued by the
            Ministry of Foreign Affairs. Lancewood AI Solutions is not
            responsible for any consequences resulting from an incorrect
            assessment of security risks, and the User is expected to
            independently verify information from official sources. Lancewood AI
            Solutions accepts no liability for damages or adverse consequences
            arising from following advice that differs from official safety
            guidelines.
          </Text>
          <Text>
            18.4. Lancewood AI Solutions disclaims any liability for direct,
            indirect, or consequential damages resulting from the use of the
            Content. This includes, but is not limited to, damages caused by
            incorrect or incomplete information from external suppliers,
            decisions made based on provided advice, or errors arising from
            references to external services.
          </Text>

          {/* 19. Links to third-party websites */}
          <Heading as="h3" size="md">
            19. Links to third-party websites
          </Heading>
          <Text>
            19.1. NOMAD360 may contain references to third-party websites,
            platforms or services. These references are provided solely for the
            information and convenience of the User. The inclusion of such links
            does not imply any endorsement or recommendation of the content,
            products or services offered on such websites by Lancewood AI
            Solutions.
          </Text>
          <Text>
            19.2. Lancewood AI Solutions has no control over and is not
            responsible for the availability, accuracy, legality, or content of
            third-party websites, nor for the products, services or information
            provided through them. Use of such external websites is entirely at
            the User's own risk.
          </Text>
          <Text>
            19.3. User should be aware that when visiting third-party websites,
            the terms and privacy policies of those websites will apply.
            Lancewood AI Solutions advises the User to read these terms and
            policies carefully before using third-party services.
          </Text>
          <Text>
            19.4. Lancewood AI Solutions assumes no liability for any damages or
            adverse consequences arising from the use of or reliance on any
            content, products or services provided through third-party websites.
            The responsibility for taking precautions, such as checking the
            reliability and safety of these external sources, lies entirely with
            the User.
          </Text>

          {/* 20. Intellectual property Input and Content */}
          <Heading as="h3" size="md">
            20. Intellectual property Input and Content
          </Heading>
          <Text>
            20.1. User grants Lancewood AI Solutions a limited, non-exclusive
            and non-transferable license to access, use, store, reproduce,
            transmit, display, publish, distribute and edit the Input solely for
            the purpose of generating the Content.
          </Text>
          <Text>
            20.2. User warrants that they are authorized to provide the Inputs
            they make available to Lancewood AI Solutions as part of the
            service. The User also declares that the Input does not infringe
            upon any third-party rights and hereby indemnifies Lancewood AI
            Solutions against any claims, liabilities, costs, and damages
            resulting from such infringements.
          </Text>
          <Text>
            20.3. To the extent that any Content generated by the User through
            NOMAD360 is subject to intellectual property rights, such rights
            shall remain the property of the User. Lancewood AI Solutions does
            not claim any ownership rights over this Content. However, the User
            grants Lancewood AI Solutions a license to use, modify, and
            distribute the Content (insofar as it concerns anonymized personal
            data) for the purpose of improving NOMAD360 and the AI model.
          </Text>
        </VStack>
        {/* Disclaimer linking to Dutch version */}
        <Text mb={8} mt={8} fontStyle="italic" fontWeight="bold">
          These terms of service are an English translation of the official Dutch
          version. In case of any discrepancies, the Dutch version takes
          precedence. For the Dutch version, click{" "}
          <ChakraLink
            as={RouterLink}
            to="/policies/terms-of-service/nl" // or your actual Dutch Terms route
            color="blue.500"
            textDecoration="underline"
          >
            here
          </ChakraLink>
          .
        </Text>
      </Box>
      <JoinCommunitySection />
      <Footer />
      <BackToTopButton />
    </Box>
    </>
  );
};

export default TermsOfService;
